import Logger from '../../utils/Logger';

let createActionName = require('../util').createActionName('linkkipalvelu');

let { id: module_id } = module;
const logger = new Logger(module_id);

export const GET_LINK = createActionName('GET_LINK');
export const RECEIVE_LINK = createActionName('RECEIVE_LINK');
export const GET_LINK_FAILED = createActionName('GET_LINK_FAILED');
export const CLEAR_LINK_CACHE = createActionName('CLEAR_LINK_CACHE');

export const getLink = (codeSet, key) => ({
  type: GET_LINK,
  codeSet,
  key,
});

export const receiveLink = (codeSet, key, data) => ({
  type: RECEIVE_LINK,
  codeSet,
  data,
  key,
});

export const getLinkFailed = (codeSet, key, error) => ({
  type: GET_LINK_FAILED,
  codeSet,
  key,
  error,
});

export const clearLinkCache = (codeSet) => ({
  type: CLEAR_LINK_CACHE,
  codeSet,
});

export const doGetLink = (codeSet, key) => (dispatch, getState, services) => {
  if (
    getState().linkkipalvelu[codeSet] == null ||
    getState().linkkipalvelu[codeSet][key] == null
  ) {
    return new Promise((resolve, reject) => {
      dispatch(getLink(codeSet, key));
      services.api
        .getLinkedValue({ codeSetName: codeSet, keys: key })
        .then((data) => {
          resolve(dispatch(receiveLink(codeSet, key, data)));
        })
        .catch((error) => {
          logger.error(error);
          resolve(dispatch(getLinkFailed(codeSet, key, error)));
        });
    });
  }
};
